export default __webpack_public_path__ + "src/images/packages/qambathi-mountain-lodge/ae5903b1617c1bd5b33c099a9b536adf-2.jpg";